import React from 'react';
import styled from 'styled-components';

const ListItem = styled.li.attrs({})`
  /* border-top: 2px solid #4db2ec;
  background: #f3f4f6; */
  margin: 0;
  font-family: 'Montserrat';
  font-size: 1.125rem;
  color: #afafaf;
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  max-width: 1040px;
  display: flex;
  justify-content: space-between;
  a {
    text-decoration: none;
    color: #424242;
    width: auto;
    padding: 14px 0;
    margin: 0 0.5rem;
    text-align: center;
    height: 100%;
    text-transform: capitalize;
  }
  a:hover,
  a:active,
  a.active {
    color: #202020;
    font-weight: bold;
  }
`;

const StickySpecsBar = props => {
  let list;

  if (props.items) {
    list = props.items.map(item => {
      return (
        <a key={item.title} href={`#${item.title.toLowerCase()}`}>
          {item.title.toLowerCase()}
        </a>
      );
    });
  }

  return (
    <ul
      id={props.id}
      className="ma0 pa0 w-100 flex justify-center"
      style={{
        zIndex: '88',
        borderTop: '2px solid #4db2ec',
        background: '#f3f4f6',
        lineHeight: '0.8',
        ...props.style
      }}
    >
      <ListItem className="anchor">{list}</ListItem>
    </ul>
  );
};

export default StickySpecsBar;
